import React from 'react';
import './luckObservation.css';
import { apiService } from '../../common/apiCallService';
import Loading from '../Loading.js';
import { baseUrl } from '../../common/config.js';
import MediaQuery from 'react-responsive';
import ReactTooltip from "react-tooltip";
import TableDeskBody from './TableDeskBody';
import TableSmallBody from './TableSmallBody';
import { getColor } from '../../common/ThemeService';
import i18next from 'i18next';
class LuckObservation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
        }
    }

    generateCardLinks(cards) {
        let imgUrls = []
        let typeOfCards = ['club', 'diamond', 'heart', 'spade']
        for (let card of cards) {
            let cardName = typeOfCards.find((type) => type.indexOf(card[card.length - 1]) > -1)
            cardName = '/images/cards1x/' + cardName + '/' + card.trim() + '.png'
            imgUrls.push(cardName)
        }
        return imgUrls
    }

    getLast48HoursAllInHands = () => {
        this.setState({ loading: true });
        apiService(`${baseUrl}/reportCard/getLast48HoursAllInHands`,
            {
                gameType: this.props.gameType,
                gameSubType: 'Texas Holdem',
                ringType: this.props.ringType,
                observation: 'Luck',
                accountName: localStorage.getItem('accountName')
            },
            (data) => {

                this.setState({ loading: false });
                this.setState({ handList: data })
            }, (error) => {
                console.log("Error:", error)
                this.setState({ loading: false })
            })

    }

    render() {
        const themeColor = getColor()
        const handList = Object.keys(this.props.handList).length > 0
            ? [...new Set([...this.props.handList.topLostHands, ...this.props.handList.topWonHands])].sort((a, b) => b.ev - a.ev)
            : {}
        const { totalHands = 0, wonNetAmount = 0, ev = 0, luck = '', luckId = 0 } = Object.keys(this.props.handList).length > 0
            && this.props.handList.handAgg
        return (
            Object.keys(this.props.handList).length > 0
                ?
                <div>
                    {this.state.loading ? <Loading /> : null}
                    <ReactTooltip id='luckHeaderToolTip' place='bottom' effect='solid' className="custLuckTooltip">
                        <div className="custLuckTooltipContent">
                            <div> Calculates the difference between the value based on the probability of </div>
                            <div> your cards winning the hand and the actual result, when you are all-in </div>
                            <div> before showdown.</div>
                        </div>
                    </ReactTooltip>
                    <ReactTooltip id='EvAdjustedToolTip' place='bottom' effect='solid' className="custLuckTooltip">
                            <div className="custLuckTooltipContent">Your winrate, adjusted depending on your luck in all-in scenarios</div>
                    </ReactTooltip>
                    
                    <div className="luckHeader">
                        {totalHands === 0
                            ? <span>We’ll show you how lucky you’ve been once you start playing&nbsp;</span>
                        : <span>You Got <span className={`luckProgressText${luckId} luckTexxt`} style={{ backgroundColor: 'white' }}>{luck}</span> {luck==='average' && <b>lucky</b>} when you went all-in!&nbsp;</span>}
                        <i className="fa fa-info-circle luckInfo" data-tip data-for="luckHeaderToolTip"
                            style={{
                                color: themeColor,
                            }}
                        ></i>
                    </div>
                    <div className="luckSubHeader">
                        <span className="luckNoOfHands">Number of all in hands:&nbsp;{totalHands}</span>
                        <span className="luckNoOfWon">Total won:&nbsp;{wonNetAmount >= 0 ? '+' : '-'}£{(Math.abs(wonNetAmount)).toFixed(2)}&nbsp;&nbsp;</span>
                        <span className="luckNoOfEv">{i18next.t("lable.Winrate – All-In EV Adjusted")}&nbsp;<i className="fa fa-info-circle luckInfo" data-tip data-for="EvAdjustedToolTip"
                            style={{
                                color: themeColor,
                            }}
                        ></i>&nbsp;:&nbsp;{ev >= 0 ? '+' : '-'}£{(Math.abs(ev)).toFixed(2)}</span>
                    </div>
                    <div className={`luckProgress activeLuck${luckId}`}>
                        {['luckProgressText1', 'luckProgressText2', 'luckProgressText3', 'luckProgressText4', 'luckProgressText5']
                            .map((obj, i) => <span key={i}
                                className={`luckProgressText ${luckId === (i + 1) && ` activeLuck`} ${totalHands === 0 ? 'luckProgressTextNoAllinHands' : obj}`}></span>)}
                    </div>
                    <div className={`luckDisplay ${totalHands === 0 && ' luckDisplay1'} `} >
                        <span className="">Very Unlucky</span>
                        {/* <span className="hideEVGrade">Unlucky</span>
                        <span className="hideEVGrade">Average</span>
                        <span className="hideEVGrade">Lucky</span> */}
                        <span className="">Very Lucky</span>
                    </div>
                    <MediaQuery minWidth={991} >
                        <div className="topEvHands luckHide">My Top All-in Hands</div>
                    </MediaQuery>
                    {totalHands > 0
                        ? <div>
                            <table style={{ width: '100%' }}>
                                <MediaQuery minWidth={991} >
                                    <thead className="resp-table-head spin-repo-bottom-border ">
                                        <tr className="resp-table-tr luckTableHeader">
                                            <th className='luckCard luckTableHeader '>Cards</th>
                                            <th className='luckFlop luckTableHeader'>Flop</th>
                                            <th className='luckTurn luckTableHeader'>Turn</th>
                                            <th className='luckRiver luckTableHeader'>River</th>
                                            <th className='luckProfit luckTableHeader'>Profit</th>
                                            <th className='luckEv luckTableHeader'>EV</th>
                                            <th className='luckNote luckTableHeader'></th>
                                            <th className='luckStar luckTableHeader'></th>
                                            <th className='luckPlay luckTableHeader'></th>
                                        </tr>
                                    </thead>
                                </MediaQuery>
                                <MediaQuery minWidth={991} >
                                    <tbody>
                                        {handList.slice(0, 2).map((hand, i) =>
                                            <TableDeskBody
                                                key={i}
                                                hand={hand}
                                                isSeeMore={false}
                                                setStarFlagOfHnad={this.props.setStarFlagOfHnad}
                                                handReplayerOpen={this.props.handReplayerOpen}
                                                openNotes={(hand) => { this.props.openNotes(hand) }} />)}
                                    </tbody>
                                </MediaQuery>
                                <MediaQuery maxWidth={991} >
                                    <tbody>
                                        {handList.slice(0, 2).map((hand, i) =>
                                            <TableSmallBody
                                                key={i}
                                                hand={hand}
                                                isSeeMore={false}
                                                setStarFlagOfHnad={this.props.setStarFlagOfHnad}
                                                handReplayerOpen={this.props.handReplayerOpen}
                                                openNotes={(hand) => { this.props.openNotes(hand) }} />)}
                                    </tbody>
                                </MediaQuery>
                            </table>
                            {handList.length > 2 && <div className="mygameLuckSeeMoreHands" onClick={() => { this.props.seeMoreHands() }}
                                style={{
                                    color: themeColor,
                                    borderColor: themeColor,
                                }}
                            > See More Hands</div>}
                        </div>
                        :
                        <div className="NoAllInHands">
                            <div className="NoAllInHandsMsg"><center>Your hands will appear here when you play</center></div>
                        </div>
                    }
                </div >
                : null
        )
    }
}


// const TableSmallBody = (props) => {
//     let profityStyle = props.hand.profit >= 0 ? { color: '#6DB92C' } : { color: '#D32121' }
//     return (
//         <tr>
//             <td className="mygameluck-tr holeCardMob">
//                 {props.hand[`holeCardUrl`].map((cardUrl, index) => {
//                     return cardUrl === ''
//                         ? <div key={index} className="luckHandCards" ></div>
//                         : <img
//                             key={index}
//                             className="luckHandCardsWithCard"
//                             src={`https://mygame-dev.mypartypokerlive.com${cardUrl}`}
//                         />
//                 })}
//             </td>
//             <td className="mygameluck-tr profitMob" style={profityStyle}>{props.hand.profit >= 0 ? '+' : '-'}{props.hand.gameType === 'cash' && '$'}{(Math.abs(props.hand.profit)).toFixed(2)}</td>
//             <td className="mygameluck-tr luckEditNote"
//                 data-toggle="modal"
//                 data-target="#EditNoteModal"
//                 onClick={(e) => {
//                     e.preventDefault();
//                     props.openNotes({})
//                 }}><i className="fa fa-pencil-square-o "></i></td>
//             <td className="mygameluck-tr luckStar"><i className="fa fa-star-o"></i></td>
//             <td className="mygameluck-tr luckReplay"><i className="fa fa-play-circle"></i></td>
//         </tr>
//     )
// }

// const TableDeskBody = (props) => {
//     let profityStyle = props.hand.profit >= 0 ? { color: '#6DB92C' } : { color: '#D32121' }
//     return (
//         <tr>
//             {['hole', 'flop', 'turn', 'river'].map((street, i) =>
//                 <td key={i} className="mygameluck-tr holeCardMob">
//                     {props.hand[`${street}CardUrl`].map((cardUrl, index) => {
//                         return cardUrl === ''
//                             ? <div key={index} className="luckHandCards" ></div>
//                             : <img
//                                 key={index}
//                                 className="luckHandCardsWithCard"
//                                 src={`https://mygame-dev.mypartypokerlive.com${cardUrl}`}
//                             />

//                     })}
//                 </td>
//             )}
//             <td className="mygameluck-tr profitMob" style={profityStyle}>{props.hand.profit >= 0 ? '+' : '-'}{props.hand.gameType === 'cash' && '$'}{Math.abs(props.hand.profit).toFixed(2)}</td>
//             <td className="mygameluck-tr ">{(props.hand.ev).toFixed(2)}</td>
//             <td className="mygameluck-tr luckEditNote"
//                 data-toggle="modal"
//                 data-target="#EditNoteModal"
//                 onClick={(e) => {
//                     e.preventDefault();
//                     props.openNotes({})
//                 }}><i className="fa fa-pencil-square-o "></i></td>
//             <td className="mygameluck-tr luckStar"><i className="fa fa-star-o"></i></td>
//             <td className="mygameluck-tr luckReplay"><i className="fa fa-play-circle"></i></td>
//         </tr>
//     )
// }

export default LuckObservation;


/** WEBPACK FOOTER **
 ** ./src/components/LandingPage/LuckObservation.js
 **/